import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RoundedButton } from "../../styled/styled";

type Props = {
  onClose: () => void;
  onSubmit: () => void;
  submitDisabled?: boolean;
};

const FormSaveCancelButtons = ({
  onClose,
  onSubmit,
  submitDisabled,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        gap: "1rem",
        marginTop: "2rem",
      }}
    >
      <RoundedButton variant="outlined" onClick={onClose}>
        {t("cancel")}
      </RoundedButton>
      <RoundedButton
        variant="contained"
        disabled={submitDisabled}
        onClick={onSubmit}
      >
        {t("save")}
      </RoundedButton>
    </Box>
  );
};

export default FormSaveCancelButtons;
